import { computed } from 'vue'
import { defineStore } from 'pinia'
import { useChatAttendance } from '@/stores/chat/attendances'
import axios from 'axios'
import useChat from '@/composables/chat/useChat'
import { useUsersStore } from '@/stores/users'
const userStore = useUsersStore

export function useChatMessages() {
    const storeAttendance = useChatAttendance()

    return defineStore('messages', {
        state: () => ({
            messages: {},
            newMessagesCount: {},
            drafts: {},
            loading: {
                requestMessages: false,
            },
            transcribing: false,
            arrivedState: false,
            goToMessage: null,
        }),

        getters: {
            currentMessages: (state) => {
                const attendance = computed(() => storeAttendance().modalAttendance || storeAttendance().currentAttendance)
                if (!attendance.value) return []
 
                return state.messages[attendance.value.id] ?? []
            },
        },

        actions: {
            requestMessages(id) {
                if (!id) return

                if (!this.messages[id]) this.loading.requestMessages = true
             
                this.newMessagesCount[id] = 0

                axios.defaults.baseURL =  import.meta.env.VITE_API_ENDPOINT || window.origin + '/api_v2/api'

                axios.get(`/v1/chat/attendances/${id}/messages`)
                    .then(res => {
                        this.messages[id] = res.data.data
                        setTimeout(() => useChat.scrollToBottom(), 1)
                    })
                    .finally(() => {

                        this.loading.requestMessages = false

                        axios.defaults.baseURL =  import.meta.env.VITE_API_ENDPOINT || window.origin + '/api_v2/api'

                    } )
            },
            addMessage(message) {
                if (!message.attendance_id) return

                if (!this.messages[message.attendance_id]) this.messages[message.attendance_id] = []
                
                this.messages[message.attendance_id].push(message)
            },
            transcribeAudio(attendance_id, message_id){
                axios.defaults.baseURL = import.meta.env.VITE_API_ENDPOINTLOCAL || window.origin + '/api-v2'
                this.transcribing = message_id;

                axios.post(`/attendances/${attendance_id}/messages/${message_id}/transcribe`)
                .then(res => {
                
                    if(res.data?.id){

                        const position = this.messages[attendance_id].findIndex(element => element.id === message_id);

                        
                         this.messages[attendance_id].splice(position+1, 0, res.data);

                    }
                })
                .finally(() => {
                    this.transcribing = false;
                    axios.defaults.baseURL =  import.meta.env.VITE_API_ENDPOINT || window.origin + '/api_v2/api'
                    
                })

            },

            /**
             * @param {Number} attendanceId
             * @param {Object} input
             */
            receiveMessage(attendanceId, input) {
                   

               
              

                if(this.messages[attendanceId] && input.temp_id){

                    const index = this.messages[attendanceId].findIndex(el => el.temp_id === input.temp_id)
                    
                    if(index !== -1){
                        //console.log(index, input)
                        this.messages[attendanceId][index] = input;
                    }
                }

                if (!this.messages[attendanceId]) return

               /*if (input.temp_id) {
    
                const index = this.messages[attendanceId].findIndex(el => el.temp_id === input.temp_id)
                this.messages[attendanceId][index] = input;
 
               } else {

                    this.messages[attendanceId].push(input)
                
               } */ // ALTEREI ESSA LÓGICA (VALIDAR DEPOIS)
             
               if(input.type == "received"){
                        
                    this.messages[attendanceId].push(input)

                } else {

                     if(input.submitted_by_user && input.submitted_by_user == userStore().me?.id){
 
                        const index = input.temp_id
                            ? this.messages[attendanceId].findIndex(el => el.temp_id === input.temp_id)
                            : -1

                        if(index !== -1){
                            this.messages[attendanceId][index] = input;
                        } else {
                            const alreadyExists = this.messages[attendanceId].some(el => el.id && el.id === input.id)
                            if(!alreadyExists) this.messages[attendanceId].push(input)
                        }
                        
                     } else {

                        const index = input.id
                            ? this.messages[attendanceId].findIndex(el => el.id && Number(el.id) === Number(input.id))
                            : -1

                        if (index !== -1) {
                            this.messages[attendanceId][index] = input;
                        } else {
                            this.messages[attendanceId].push(input)
                        }
                        
                    }
                }
 


            },
        },
    })
}
